var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-0 py-md-10"},[_c('v-container',[_c('SectionTitle',{staticClass:"mb-4",attrs:{"title":"New arrivals"}}),_c('ItemCardDefaultSlider',{attrs:{"columns":_vm.columns,"items":_vm.items}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }